import apiEndpoint from '../components/config/data';

export const isDevOrQaEnvironment = () => {
  const apiMatches =
    apiEndpoint.includes('qa') ||
    apiEndpoint.includes('localhost') ||
    apiEndpoint.includes('127.0.0.1');

  if (typeof window === 'undefined') {
    return apiMatches;
  }

  return (
    apiMatches ||
    window.location.hostname.includes('localhost') ||
    window.location.hostname.includes('qa')
  );
};

export const getSpotOnDashboardUrl = () => {
  return isDevOrQaEnvironment()
    ? 'https://qa-dashboard.spoton.com/profit-assist/'
    : 'https://dashboard.spoton.com/profit-assist/';
};
